import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Wenn es einen Hash gibt (z.B. #gdpr), lass den Browser zum Hash springen
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 0);
    } else {
      // Ansonsten scrolle nach oben
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
